import { memo } from 'react'
import './ButtonWhite.css'
import { useTranslation } from 'react-i18next'

function ButtonWhiteComponent(props) {
	const { t } = useTranslation()

	return (
		<button
			type={props?.type}
			onClick={props?.onClick}
			className={props?.light ? 'button-structure__light' : 'button-structure'}
			style={props?.disabled ? {backgroundColor : '#CCCCCC', color: 'white', border: 'none'} : {}}
			disabled={props?.disabled}
		>
			{ t(props?.title) }
		</button>
	)
}

export const ButtonWhite = memo(ButtonWhiteComponent)